<template>
  <div class="state-password-input">
    <p
      v-if="title"
      class="state-password-input_title"
    >
      {{ title }}<span v-if="required">*</span>
    </p>
    <ValidationProvider
      v-slot="{ errors }"
      :rules="rules"
      :custom-messages="errorMessages"
      class="state-password-input_input-item-wrap"
    >
      <div
        class="state-password-input_input_item"
        :class="{error:errors.length> 0 || errorText}"
      >
        <i
          :class="leadingIcon"
          class="leading-icon"
        />
        <input
          :value="value"
          :type="passwordFieldType"
          :disabled="disabled"
          :placeholder="placeholder"
          autocomplete="on"
          @input="$_valueChange($event)"
          @keyup.enter="$_changeValueEnter($event)"
        >
        <i
          :class="icon"
          class="after-icon"
          @click="$_switchVisibility()"
        />
      </div>
      <div
        v-if="$_isValidTextActive(errors)"
        class="invalid-text"
      >
        <i class="icon-warning invalid-icon" />
        <p
          v-for="(text_e,text_k) in errors"
          :key="text_k"
          class="text"
        >
          {{ $t(text_e) }}
        </p>
        <p
          v-if="errorText"
          class="text"
        >
          {{ $t(errorText) }}
        </p>
      </div>
    </ValidationProvider>
  </div>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { required,regex } from "vee-validate/dist/rules";
extend("required", required)
extend("regex", regex);
export default {
  name: "StatePasswordInput",
  components: {
    ValidationProvider,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    afterIcon: {
      type: String,
      default: "",
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    errorText: {
      type: String,
      default: "",
    },
    errorMessages: {
      type: Object,
    }
  },
  data: () => ({
    inputContent: "",
    passwordFieldType: "password",
    icon: "icon-eye-close",
  }),
  mounted() {
    this.inputContent = this.value;
  },
  methods: {
    $_isValidTextActive(errors) {
      if (errors.length > 0 || this.errorText) {
        return true;
      } else {
        return false;
      }
    },
    $_valueChange(e) {
      this.$emit("input", e.target.value);
    },
    $_changeValueEnter($event) {
      this.$emit("input", $event.target.value);
      this.$emit("enter");
    },
    $_switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.icon =
        this.icon === "icon-eye-close" ? "icon-eye-open" : "icon-eye-close";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/state-password-input";
</style>